import React from "react";

// Import images
import agriculture1 from "../assets/agriculture1.webp";

// 🔹 Reusable Section Component
const SectionWithImages = ({ id, title, text, images, reverse = false, labels = [] }) => {
    return (
        <div id={id} className={`flex flex-col ${reverse ? "sm:flex-row-reverse" : "sm:flex-row"} items-center text-white bg-gray-900 p-12 sm:p-20 gap-8`}>
            {/* Full-Width Text for Image-less Sections */}
            <div className={`w-full ${images.length === 0 ? "text-center" : "sm:w-1/2 text-left"}`}>
                <h2 className="text-4xl sm:text-5xl font-bold mb-6 animate-fadeIn">{title}</h2>
                <p className="text-lg sm:text-xl animate-fadeIn animate-delay-300 text-justify whitespace-pre-line">{text || ""}</p>
            </div>

            {/* Images Section with Labels (only if images exist) */}
            {images.length > 0 && (
                <div className={`w-full sm:w-1/2 grid grid-cols-1 ${images.length > 1 ? "sm:grid-cols-2" : ""} gap-4`}>
                    {images.map((img, index) => (
                        <div key={index} className="flex flex-col items-center">
                            <img
                                src={img}
                                alt={`Agriculture Biostimulant ${index + 1}`}
                                className="rounded-lg shadow-lg transform hover:scale-105 transition duration-300 w-full h-64 sm:h-80 object-cover"
                            />
                            {/* Add Figure Label if Provided */}
                            {labels[index] && <p className="mt-2 text-sm sm:text-base text-gray-300 text-center">{labels[index]}</p>}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const Agriculture = () => {
    return (
        <div className="w-full">
            {/* 🔹 Agriculture */}
            <SectionWithImages
                id="agriculture"
                title="Agriculture: Algae as Biostimulant"
                text="Intensive use of chemical fertilizers negatively impacts soil and the environment. Proalgenix focuses on developing formulations by blending various strains of microalgae to offer biofertilizers or biostimulants—in powder or liquid form—targeted at agriculture and gardening. Our products ensure greater functionality and provide direct benefits to plants and crops."
                images={[agriculture1]}
                reverse={false}
            />
        </div>
    );
};

export default Agriculture;
